import React from 'react';
import { Badge } from '@/components/ui/badge';
import { CheckCircle, AlertCircle, Clock, Send } from 'lucide-react';

interface ImportedUserStatusBadgeProps {
  status: string;
  invitationStatus?: string;
}

export const ImportedUserStatusBadge = ({ status, invitationStatus }: ImportedUserStatusBadgeProps) => {
  if (status === 'invited' && invitationStatus === 'accepted') {
    return (
      <Badge variant="outline" className="text-yellow-600 border-yellow-600">
        <CheckCircle className="h-3 w-3 mr-1" />
        Accepted
      </Badge>
    );
  }
  
  switch (status) {
    case 'imported':
      return (
        <Badge variant="outline" className="text-gray-600 border-gray-600">
          <Clock className="h-3 w-3 mr-1" />
          Imported
        </Badge>
      );
    case 'invited':
      return (
        <Badge variant="outline" className="text-blue-600 border-blue-600">
          <Send className="h-3 w-3 mr-1" />
          Invited
        </Badge>
      );
    case 'error':
      return (
        <Badge variant="outline" className="text-red-600 border-red-600">
          <AlertCircle className="h-3 w-3 mr-1" />
          Error
        </Badge>
      );
    default:
      return <Badge variant="secondary">{status}</Badge>;
  }
};